import React from 'react';
import { Save, Trash2 } from 'lucide-react';

export default function EmergencyTeamTable({
  weeks,
  users,
  drafts,
  onDraft,
  onSave,
  onDelete,
  savingKey,
}) {
  const rows = [...(weeks || [])];
  while (rows.length < 5) rows.push({ is_empty: true, week_start: `empty-${rows.length}` });

  return (
    <div style={tableWrap}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thStyle, width: 94 }}>주말</th>
            <th style={thStyle}>예약팀 담당자</th>
            <th style={{ ...thStyle, width: 70 }} />
          </tr>
        </thead>
        <tbody>
          {rows.map((week) => {
            if (week.is_empty) {
              return (
                <tr key={week.week_start} style={rowStyle}>
                  <td style={emptyTdStyle}>&nbsp;</td>
                  <td style={emptyTdStyle}>&nbsp;</td>
                  <td style={emptyTdStyle}>&nbsp;</td>
                </tr>
              );
            }
            const draft = drafts[week.week_start] || {};
            const isSaving = savingKey === week.week_start;
            return (
              <tr key={week.week_start} style={rowStyle}>
                <td style={tdStyle}>
                  <div style={dateMainStyle}>{shortDate(week.week_start)}</div>
                  <div style={dateSubStyle}>~ {shortDate(week.week_end)}</div>
                </td>
                <td style={tdStyle}>
                  <select
                    value={draft.user_id || ''}
                    onChange={(e) => onDraft(week.week_start, { user_id: e.target.value })}
                    style={selectStyle}
                  >
                    <option value="">선택</option>
                    {users.map((user) => (
                      <option key={user.id} value={user.id}>{user.name}</option>
                    ))}
                  </select>
                </td>
                <td style={{ ...tdStyle, textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button
                    type="button"
                    onClick={() => onSave(week.week_start)}
                    disabled={isSaving || !draft.user_id}
                    style={iconButton('#2563eb', isSaving || !draft.user_id)}
                    title="저장"
                  >
                    <Save size={13} />
                  </button>
                  {draft.id && (
                    <button
                      type="button"
                      onClick={() => onDelete(week.week_start)}
                      disabled={isSaving}
                      style={{ ...iconButton('#dc2626', isSaving), marginLeft: 4 }}
                      title="삭제"
                    >
                      <Trash2 size={13} />
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function shortDate(value) {
  return String(value || '').slice(5);
}

const tableWrap = {
  background: 'var(--bg-card)',
  height: 257,
  overflowX: 'auto',
  overflowY: 'hidden',
};

const tableStyle = {
  width: '100%',
  minWidth: 280,
  borderCollapse: 'collapse',
  tableLayout: 'fixed',
};

const thStyle = {
  height: 32,
  padding: '0 8px',
  textAlign: 'left',
  fontSize: 11,
  lineHeight: '32px',
  color: 'var(--text-sub)',
  background: 'rgba(37,99,235,0.05)',
  borderBottom: '1px solid var(--border)',
  boxSizing: 'border-box',
};

const tdStyle = {
  height: 45,
  padding: '6px 7px',
  borderBottom: '1px solid var(--border)',
  verticalAlign: 'middle',
  boxSizing: 'border-box',
};

const rowStyle = {
  height: 45,
};

const emptyTdStyle = {
  ...tdStyle,
  background: 'rgba(148,163,184,0.035)',
};

const dateMainStyle = {
  fontWeight: 900,
  color: 'var(--text)',
  fontSize: 12,
  lineHeight: '16px',
};

const dateSubStyle = {
  fontSize: 10,
  lineHeight: '12px',
  color: 'var(--text-sub)',
};

const selectStyle = {
  width: '100%',
  height: 30,
  border: '1px solid var(--border)',
  borderRadius: 6,
  background: 'var(--bg-card)',
  color: 'var(--text)',
  padding: '0 7px',
  boxSizing: 'border-box',
  fontSize: 12,
};

function iconButton(bg, disabled) {
  return {
    width: 28,
    height: 28,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    borderRadius: 6,
    color: '#fff',
    background: disabled ? '#9ca3af' : bg,
    cursor: disabled ? 'not-allowed' : 'pointer',
  };
}
